/* ========================================================================
   Newsletter form
 ========================================================================== */

app.newsletterForm = (function () {
  'use strict';

  function init() {
    const form = document.querySelector('[data-newsletter-form]');
    if (!form) return;

    const submitButton = form.querySelector('[type="submit"]');
    const tagField = form.querySelector('[name="newsletter_tag"]');
    const firstNameField = form.querySelector('[name="newsletter_firstname"]');
    const lastNameField = form.querySelector('[name="newsletter_lastname"]');
    const emailField = form.querySelector('[name="newsletter_email"]');
    const csrfField = form.querySelector('[name="__RequestVerificationToken"]');

    form.addEventListener('submit', (event) => {
      event.preventDefault();
    });

    form.addEventListener('validation', (event) => {
      if (event.detail.valid === false) return;

      submitButton.setAttribute('disabled', 'disabled');

      var data = {
        tag: tagField.value,
        firstName: firstNameField.value,
        lastName: lastNameField.value,
        emailAddress: emailField.value,
      };

      console.log(data);

      fetch('/api/newsletter/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfField.value,
          Culture: util.uiCulture,
          HomePageId: util.homePageId,
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success === true) {
            Toast(data.message, 'success', 10000);
            form.reset();

            // DATALAYER
            app.dataLayer.pushEvent('footerNewsletterSignup', {
              pageUrl: window.location.pathname,
            });
          } else if (data.success === false) {
            Toast(data.message, 'error', 10000);

            // DATALAYER
            app.dataLayer.pushEvent('footerNewsletterError', {
              pageUrl: window.location.pathname,
              errorMessage: data.message,
            });
          } else if (data.status === 400) {
            Toast('Unknown error.', 'error', 10000);

            // DATALAYER
            app.dataLayer.pushEvent('footerNewsletterError', {
              pageUrl: window.location.pathname,
              errorMessage: 'Unknown error',
            });
          }

          setTimeout(() => {
            submitButton.removeAttribute('disabled');
          }, 1000);
        })
        .catch((error) => {
          console.error('Error:', error);
          Toast('Unknown error.', 'error', 10000);

          setTimeout(() => {
            submitButton.removeAttribute('disabled');
          }, 1000);
        });
    });
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();

app.newsletterForm.init();
